class ImageWidget {

  constructor() {
    this.initializeImageWidgets();
  }

  initializeImageWidgets() {
    const imageWidgets = document.querySelectorAll('.image-widget');
    imageWidgets.forEach((item) => {
      item.addEventListener('click', (e) => {
        item.classList.toggle('active');
      });
      item.addEventListener('mouseleave', (e) => {
        item.classList.remove('active');
      });
    });
  }

}

document.addEventListener('DOMContentLoaded', () => {
  new ImageWidget();
})
